<template>
  <el-card>
    <loading :loading_ok="loading_ok"></loading>
    <span class="title">教务管理</span>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        label="教师管理"
        name="TEACHER"
        v-if="role != '老师'"
      ></el-tab-pane>
      <el-tab-pane label="班级管理" name="班级"></el-tab-pane>
    </el-tabs>

    <div class="bottom_box">
      <div>
        <el-button
          size="mini"
          type="success"
          icon="el-icon-plus"
          v-if="activeName == '班级'"
          @click="add_class_but()"
        >
          添加班级
        </el-button>
        <el-button
          size="mini"
          type="success"
          icon="el-icon-plus"
          v-if="activeName == 'TEACHER'"
          @click="addTeacher()"
        >
          添加教师
        </el-button>
      </div>

      <el-table :data="tableData" class="table" border stripe>
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="User.Nickname" label="名称"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="success"
              icon="el-icon-plus"
              size="mini"
              @click="add_class_teacher(scope.row.Slug)"
              v-if="activeName == '班级' && role == 'ADMIN'"
            >
              老师管理
            </el-button>
            <el-button
              type="success"
              icon="el-icon-plus"
              size="mini"
              @click="add_tudent(scope.row.Slug)"
              v-if="activeName == '班级' && role != 'STUDENT'"
            >
              学生管理
            </el-button>
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="edit_class(scope.row)"
              v-if="activeName == '班级'"
            >
              修改
            </el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              v-if="activeName == '班级'"
              @click="delete_classes_button(scope.row.Id)"
            >
              删除题库
            </el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="delete_headmaster(scope.row.Id)"
              v-if="activeName == 'TEACHER'"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 添加教师弹框 -->
    <el-dialog
      title="添加账号"
      :visible.sync="headmaster_frame"
      :close-on-click-modal="false"
      width="40%"
    >
      <p>{{ current }}</p>
      <el-select
        filterable
        class="elselect"
        v-model="query.user_headmaster"
        placeholder="请选择用户作为教师"
      >
        <el-option
          v-for="item in headmaster_data"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="headmaster_frame = false" size="mini"
          >取消</el-button
        >
        <el-button type="primary" @click="add_teacher" size="mini">
          确定
        </el-button>
      </span>
    </el-dialog>

    <!-- 添加班级弹框 -->
    <el-dialog
      :title="query.id ? '修改班级' : '添加班级'"
      :visible.sync="dialog_class"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-input placeholder="请输入班级名称" v-model="query.name"></el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog_class = false" size="mini">
          取消
        </el-button>
        <el-button type="primary" @click="add_dialog_class" size="mini">
          确定
        </el-button>
      </span>
    </el-dialog>

    <!-- 删除题库弹框 -->
    <el-dialog
      title="删除题库"
      :visible.sync="bank_classes"
      :close-on-click-modal="false"
      width="50%"
    >
      <el-select
        v-model="class_form.sheetId"
        clearable
        filterable
        placeholder="请选择题库"
        style="width: 50%;"
      >
        <el-option
          v-for="item in bank_option"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>

      <span slot="footer" class="dialog-footer">
        <el-button @click="bank_classes = false" size="mini">
          取消
        </el-button>
        <el-button type="primary" @click="classes_submit" size="mini">
          确定
        </el-button>
      </span>
    </el-dialog>

    <!-- 添加学生弹框 -->
    <el-dialog
      title="学生管理"
      :visible.sync="dialog_student"
      :close-on-click-modal="false"
      width="60%"
    >
      <el-select
        filterable
        class="elselect"
        v-model="student_form.student"
        placeholder="请选择学生"
      >
        <el-option
          v-for="item in headmaster_data"
          :key="item.ID"
          :label="item.Name"
          :value="item.Name"
        >
        </el-option>
      </el-select>

      <el-button
        @click="add_dialog_student"
        type="primary"
        size="small"
        style="margin-left:20px;"
      >
        确定
      </el-button>

      <el-table :data="tab_student" class="tab_student_class" border stripe>
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="Name" label="学生"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="delete_student(scope.row.Name)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog_student = false" size="mini">
          取消
        </el-button>
      </span>
    </el-dialog>

    <!-- 添加老师弹框 -->
    <el-dialog
      title="老师管理"
      :visible.sync="teacher_classes"
      :close-on-click-modal="false"
      width="60%"
    >
      <el-select
        v-model="teacherId"
        clearable
        filterable
        placeholder="请选择老师"
      >
        <el-option
          v-for="item in class_teacher"
          :key="item.Name"
          :label="item.Name"
          :value="item.Name"
        >
        </el-option>
      </el-select>

      <el-button
        @click="teacher_classes_button"
        type="primary"
        size="small"
        style="margin-left:20px;"
      >
        确定
      </el-button>

      <el-table :data="teacher_table" class="tab_student_class" border stripe>
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="Name" label="老师"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="delete_teacher(scope.row.Name)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="teacher_classes = false" size="mini">
          取消
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import loading from "@/components/loading.vue";
import { add_class_api, get_class_api, edit_class_api } from "@/api/home.js";
import {
  get_add_principal,
  getAllUser,
  campus_add_principal,
  delete_principal,
  get_school_role,
  post_user_school,
} from "@/api/admin.js";
import { get_class_sheet_api, post_remove_sheet_api } from "@/api/question.js";

export default {
  computed: {
    ...mapGetters(["userInfo", "current"]),
  },
  components: {
    loading,
  },

  data() {
    return {
      rules: {
        // 验证用户名是否合法
        username: [
          { required: true, message: "请输入登录账号", trigger: "blur" },
          {
            min: 3,
            max: 10,
            message: "长度在 3 到 10 个字符",
            trigger: "blur",
          },
        ],
        // 验证密码是否合法
        password: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
      tableData: [],
      headmaster_frame: false,
      dialog_class: false,
      dialog_student: false,
      bank_classes: false,
      form: {},
      activeName: "TEACHER",
      query: {
        user_headmaster: "", //教师
        name: "", //班级名称
      },
      student_form: { student: "", Slug: "" },
      headmaster_data: [], //所有用户数据
      tab_student: [],
      bank_option: [],
      class_form: { sheetId: "", classId: "" },
      teacher_classes: false,
      class_teacher: [],
      teacherId: "",
      teacher_table: [],
      role: "",
      loading_ok: "",
    };
  },

  watch: {
    //监听vuex数据，数据发生变化触发事件
    current() {
      this.get_principal();
    },
  },

  created() {
    this.role = JSON.parse(sessionStorage.getItem("role"));

    getAllUser().then((res) => {
      this.headmaster_data = res.data;
      console.log(res.data);
    });

    if (this.role != "老师") {
      this.get_principal();
    } else {
      this.activeName = "班级";
      this.get_class();
    }
  },

  methods: {
    // 获取班级
    get_class() {
      get_class_api(this.current).then((res) => {
        this.tableData = res.data;
        this.loading_ok = false;
      });
    },

    // 添加按钮
    addTeacher() {
      if (this.activeName == "班级") {
        if (!this.query.name) {
          this.$message.error("班级名称不能为空！");
          return false;
        }
        this.$confirm("确定添加班级吗？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false,
        })
          .then(() => {
            add_class_api(this.current, { name: this.query.name }).then(() => {
              this.get_class();
              this.$message.success("添加成功！");
              this.query.name = "";
            });
          })
          .catch(() => {
            this.$message.warning("您已取消操作！");
          });
      } else {
        this.query.user_headmaster = "";
        this.headmaster_frame = true;
      }
    },

    //获取老师
    get_principal() {
      if (this.activeName == "TEACHER") {
        let id = JSON.parse(localStorage.getItem("school_id"));
        // 获取校区下面的老师
        get_school_role(id, "老师").then((res) => {
          this.tableData = res.data;
          this.class_teacher = res;
          this.loading_ok = false;
        });
      }
    },

    //切换Tab标签页
    handleClick() {
      if (this.activeName == "TEACHER") {
        this.get_principal();
      } else if (this.activeName == "班级") {
        this.get_class();
      } else if (this.activeName == "学生") {
        this.get_principal();
      }
    },

    //添加教师弹框确定按钮
    add_teacher() {
      if (!this.query.user_headmaster) {
        this.$message.error("请选择用户！");
        return false;
      }

      let data = {
        roleName: "老师",
        schoolId: JSON.parse(localStorage.getItem("school_id")),
        userId: this.query.user_headmaster,
      };

      post_user_school(data).then(() => {
        this.get_principal();
        this.$message.success("添加成功！");
        this.headmaster_frame = false;
        this.query.user_headmaster = "";
      });
    },

    //删除校区下教师
    delete_headmaster(id) {
      this.$confirm("确定删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false,
      })
        .then(() => {
          delete_principal(id).then(() => {
            this.get_principal();
            this.$message.success("删除成功！");
          });
        })
        .catch(() => {
          this.$message.warning("您已取消操作！");
        });
    },

    //修改班级
    edit_class(item) {
      // edit_class_api(id, { name: this.query.name }).then((res) => {
      //   console.log(res);
      // });
      this.dialog_class = true;
      console.log(item);
      this.query.name = item.Name;
      this.query.id = item.Id;
    },

    //添加班级
    add_class_but() {
      delete this.query.id;
      this.dialog_class = true;
    },

    //添加/修改班级弹框确定按钮
    add_dialog_class() {
      if (!this.query.name) {
        this.$message.error("班级名称不能为空！");
        return false;
      }
      if (this.query.id) {
        edit_class_api(this.query.id, { name: this.query.name }).then(() => {
          this.get_class();
          this.query.name = "";
          this.$message.success("修改成功！");
          this.dialog_class = false;
        });
      } else {
        add_class_api(this.current, { name: this.query.name }).then(() => {
          this.get_class();
          this.$message.success("添加成功！");
          this.query.name = "";
          this.dialog_class = false;
        });
      }
    },

    //添加学生按钮
    add_tudent(item) {
      this.student_form.Slug = item;
      let data = {
        domain: {
          group: "CLASS",
          name: item,
        },
        subject: {
          group: "ROLE",
          name: "STUDENT",
        },
      };
      // 获取班级下面的学生
      get_add_principal(data).then((res) => {
        this.tab_student = res.data;
      });

      this.dialog_student = true;
    },

    //添加学生弹框确定按钮
    add_dialog_student() {
      if (!this.student_form.student) {
        this.$message.error("请选择用户！");
        return false;
      }

      let data = {
        domain: {
          group: "CLASS",
          name: this.student_form.Slug,
        },
        pred: {
          group: "ROLE",
          name: "STUDENT",
        },
        succ: {
          group: "USER",
          name: this.student_form.student,
        },
      };

      campus_add_principal(data).then(() => {
        this.get_principal();
        this.$message.success("添加成功！");
        this.tab_student.push({ Name: this.student_form.student });
        this.student_form.student = "";
      });
    },

    //删除学生
    delete_student(item) {
      this.$confirm("确定删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false,
      })
        .then(() => {
          let data = {
            domain: {
              group: "CLASS",
              name: this.student_form.Slug,
            },
            pred: {
              group: "ROLE",
              name: "STUDENT",
            },
            succ: {
              group: "USER",
              name: item,
            },
          };
          delete_principal(data).then(() => {
            this.dialog_student = false;
            this.$message.success("删除成功！");
          });
        })
        .catch(() => {
          this.$message.warning("您已取消操作！");
        });
    },

    //删除题库
    delete_classes_button(id) {
      this.class_form.classId = id;
      this.class_form.sheetId = "";
      get_class_sheet_api(id).then((res) => {
        this.bank_option = res.data;
      });
      this.bank_classes = true;
    },

    //删除题库确定按钮
    classes_submit() {
      if (this.class_form.sheetId == "") {
        this.$message.error("题库不能为空！");
        return false;
      }
      post_remove_sheet_api(this.class_form).then(() => {
        this.$message.success("删除成功！");
      });
      this.bank_classes = false;
    },

    //将老师添加到班级
    add_class_teacher(id) {
      this.clas_Slug = id;
      this.teacher_classes = true;
      let data = {
        domain: {
          group: "CLASS",
          name: id,
        },
        subject: {
          group: "ROLE",
          name: "TEACHER",
        },
      };
      // 获取班级下面的学生
      get_add_principal(data).then((res) => {
        this.teacher_table = res.data;
      });
    },

    //将老师添加到班级弹框
    teacher_classes_button() {
      if (!this.teacherId) {
        this.$message.error("请选择教师！");
        return false;
      }

      let data = {
        domain: {
          group: "CLASS",
          name: this.clas_Slug,
        },
        pred: {
          group: "ROLE",
          name: "TEACHER",
        },
        succ: {
          group: "USER",
          name: this.teacherId,
        },
      };

      campus_add_principal(data).then(() => {
        this.get_principal();
        this.$message.success("添加成功！");
        this.teacher_classes = false;
        this.teacherId = "";
      });
    },

    //删除班级下面的老师
    delete_teacher(id) {
      this.$confirm("确定删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false,
      })
        .then(() => {
          let data = {
            domain: {
              group: "CLASS",
              name: this.clas_Slug,
            },
            pred: {
              group: "ROLE",
              name: "TEACHER",
            },
            succ: {
              group: "USER",
              name: id,
            },
          };
          delete_principal(data).then(() => {
            this.teacher_classes = false;
            this.$message.success("删除成功！");
          });
        })
        .catch(() => {
          this.$message.warning("您已取消操作！");
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-card {
  margin:16px;
  .title {
      color:#333;
      font-size:20px;
    }
    ul {
      display flex
      margin-top 30px
      justify-content space-between
      li {
         width 24%;
         padding: 30px;
         border 1px solid #eee
         background #f7f7f7
         display flex
         align-items center
         justify-content space-between
         .left {
           .top {
             font-size:30px;
             color:#333;
           }
           .bottom {
             font-size:12px;
             color:#999;
             margin-top:6px;
           }
         }
      }
    }
    .bottom_box {
      .table {
        margin-top:14px;
      }
    }

    .el-tabs {
      margin-top:20px;
    }

    .elselect {
      margin-top:12px;
    }
}

.tab_student_class {
  margin-top: 20px;
}
</style>
